import clsx from 'clsx';
import { FC, MouseEvent } from 'react';

import StreamCard from 'src/components/assignments/stream-card';
import { useCommonXapiContextPayloadHook } from 'src/hooks/use-common-xapi-context-payload.hook';
import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';
import {
  AssignmentColorProps,
  AssignmentsViewOptions,
} from 'src/interfaces/assignment.types';
import { TaughtLessonAssignment } from 'src/interfaces/class-stats.types';
import { XApiEventKeys } from 'src/interfaces/event.types';
import { GRADES } from 'src/interfaces/grades.types';
import eventService from 'src/services/event.service';
import { useCurrentGradeSelector } from 'src/store/features';
import { getAssignmentContent } from 'src/utils/assignments.utils';
import { generateAssignmentDataForEventPayload } from 'src/utils/xapi.utils';

import './taught-lesson-assignment-item.scss';

export interface TaughtLessonAssignmentItemProps {
  taughtLesson: TaughtLessonAssignment;
  color: AssignmentColorProps;
  grade: GRADES;
  k5Section?: AssignmentsViewOptions.TODO | AssignmentsViewOptions.PAST_WORK;
}

const TaughtLessonAssignmentItem: FC<TaughtLessonAssignmentItemProps> = ({
  taughtLesson,
  grade,
  color,
  k5Section,
}) => {
  const isMiddleSchoolView = useIsMiddleSchoolView();
  const commonXapiContextPayload = useCommonXapiContextPayloadHook();
  const userCurrentGrade = useCurrentGradeSelector();
  const isPastWorkSectionActive =
    k5Section === AssignmentsViewOptions.PAST_WORK;

  const assignmentDataForEventPayload = generateAssignmentDataForEventPayload({
    assignmentBusinessKey: taughtLesson.id,
    assignmentClassBk: taughtLesson.classBk,
    classGrade: userCurrentGrade,
    content: getAssignmentContent(taughtLesson),
  });

  const handleTaughtLessonClick = (assignmentLink: string, e: MouseEvent) => {
    return eventService.send(
      XApiEventKeys.openedAssignment,
      {
        result: {
          destinationUrl: assignmentLink,
        },
      },
      {
        result: {
          isRightClick: e.type === 'contextmenu',
          ...commonXapiContextPayload,
          ...assignmentDataForEventPayload,
        },
      },
    );
  };

  return (
    <div
      className={clsx('taught-lesson', {
        'taught-lesson--middle-school': isMiddleSchoolView,
        'taught-lesson--past-work': isPastWorkSectionActive,
      })}
    >
      <StreamCard
        assignment={taughtLesson}
        assignmentDataForEventPayload={assignmentDataForEventPayload}
        onStreamLinkClick={handleTaughtLessonClick}
        grade={grade}
        color={color}
      />
    </div>
  );
};

export default TaughtLessonAssignmentItem;
